

































import formatNumber from '@/shared/filters/format-number';
import { Component, Vue, Prop } from 'vue-property-decorator';
import utility from '@/utility/utility';
@Component
export default class ListComplain extends Vue {
    @Prop({default: {}})
    private listItem: any;

    private getOrderUrl(item: any) {
        const orderType = item.OrderType || item.orderType;
        switch (orderType) {
            case 1:
                return 'don-hang/' + item.OrderID;
            case 2:
                return 'ky-gui/' + item.OrderID;
            case 3:
                return 'thanh-toan-uy-quyen/' + item.OrderID;
            case 5:
                return 'bao-gia/' + item.OrderID;
            default:
                return '';
        }
    }

    private getOrderCode(item: any) {
        const orderType = item.OrderType || item.orderType;
        if (orderType === 1) {
            return 'MD' + item.OrderID;
        }
        if (orderType === 2) {
            return 'KG' + item.OrderID;
        }
        if (orderType === 3) {
            return 'TTH' + item.OrderID;
        }
        if (orderType === 5) {
            if (item.TransactionCode) {
                return item.TransactionCode.startsWith('QT') ? item.TransactionCode : ('QT' + item.TransactionCode);
            }
            return 'QT' + item.OrderID;
        }
        return item.OrderID;
    }

    private getOrderTypeName(orderType: number) {
        switch (orderType) {
            case 1:
                return 'Mua hộ';
            case 2:
                return 'Ký gửi';
            case 3:
                return 'Uỷ quyền TT';
            case 4:
                return 'Kiện TMĐT';
            case 5:
                return 'Báo giá';
            default:
                return '';
        }
    }

    private async viewDetail(item: any) {
        const orderType = item.OrderType || item.orderType;
        let routeData = this.$router.resolve({ name: 'detail-order-complain', params: { orderId: item.OrderID, complainId: item.ID, orderType: orderType } });
        if (orderType == 2) {
            routeData = this.$router.resolve({ name: 'detail-deposit-complain', params: { orderId: item.OrderID, complainId: item.ID, orderType: orderType } });
        }
        else if(orderType == 3) {
            routeData = this.$router.resolve({ name: 'detail-payauthority-complain', params: { orderId: item.OrderID, complainId: item.ID, orderType: orderType } });
        }
        else if(orderType == 4) {
            routeData = this.$router.resolve({ name: 'detail-ecommerce-complain', params: { orderId: item.OrderID, complainId: item.ID, orderType: orderType } });
        }
        else if(orderType == 5) {
            routeData = this.$router.resolve({ name: 'detail-quotation-complain', params: { orderId: item.OrderID, complainId: item.ID, orderType: orderType } });
        }
        window.open(routeData.href, '_blank');
    }

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }
}
